/**
 * File: blushington-gh-shop-with-me.js
 *
 * Do-no-harm CORS-only changes:
 * - Use same-origin relative proxy path: /a/rt/gh_partner.php?sl=...
 * - Remove X-Shopify-Access-Token request headers (they trigger CORS preflight and are unsafe in storefront JS)
 * - Minimal defensive JSON parsing in the two places where CORS/redirect failures produce empty/HTML responses
 *
 * NOTE: If Shopify App Proxy is still redirecting to mainwp.redthinkingllc.com, that must be fixed server-side
 * (most commonly: trailing slash on target URL or canonical redirect rules). JS cannot override that.
 */

var shortLink = "";
var partnerPhotoURL = "";
var partnerID = "";
//console.log("ghid: "+ghid);
//console.log(window.location.pathname);

$(document).ready(function () {
  // Set "Shop With Me" Cookie on partner page if no cookie already exists
  //if ( $("body.template-growthhero_partner_page")[0] && checkAffiliateCookie() == false) {
  if (document.body.classList.contains("template-growthhero_partner_page")) {
    delete_cookie("_growthhero_payload");
    delete_cookie("_blushington_shop_with_me");
    //partnerID = $("#\\#_gh_variable_partner_id").text();
    //var partnerPhotoURL = $("#\\#_gh_variable_partner_picture").text();
    partnerID = document.querySelector("#\\#_gh_variable_partner_id").textContent;
    partnerPhotoURL = document.querySelector("#\\#_gh_variable_partner_picture").textContent;
    //console.log('partnerID', partnerID);

    setShopWithMeCookie(partnerID, partnerPhotoURL);
  }

  if (window.location.href.indexOf("ghref") > -1) {
    var str_ghref = getQueryStringValue("ghref");
    var arr_ghref = str_ghref.split(":");
    var partnerID = arr_ghref[1];
    setPartner(partnerID);
  }

  $(".template-product .product-form").on("click", ".button", function () {
    //console.log("add-to-cart-button: true");
    var vid = $(this).data("variantid");
    //var blush_compare_artists = getAffiliateCookie("_blushington_compare_artists");
    if (checkAffiliateCookie()) {
      if (partnerID != "" && partnerID != blush_partnerID) {
        //console.log("cookie doesnt match ghref querystring");
        $(".current-artist").text(blush_swm.full_name);
        $(".new-artist").text($("#blush_new_swm_div .ghname").text());
        $("#new-artist").attr("data-id", $("#blush_new_swm_div .ghid").text());
        $(".shop-with-compare-text a").attr("data-variantid", vid);
        $(".shop-with-compare").css("display", "block");
      } else {
        //console.log("vid: "+ vid);
        //addItemToCart( this, vid, 1, "1", "","reload");
        //return false;
      }
    }
  });

  $(".AOD_Main_Container_Root").on("click", ".aod_btn", function () {
    //console.log("add-to-cart-button: true");
    var vid = $(this).data("variantid");
    //var blush_compare_artists = getAffiliateCookie("_blushington_compare_artists");

    if (checkAffiliateCookie()) {
      if (partnerID != "" && partnerID != blush_partnerID) {
        //console.log("cookie doesnt match ghref querystring");
        $(".current-artist").text(blush_swm.full_name);
        $(".new-artist").text($("#blush_new_swm_div .ghname").text());
        $("#new-artist").attr("data-id", $("#blush_new_swm_div .ghid").text());
        $(".shop-with-compare-text a").attr("data-variantid", vid);
        $(".shop-with-compare").css("display", "block");
      } else {
        //console.log("vid: "+ vid);
        //addItemToCart( this, vid, 1, "1", "","reload");
        //return false;
      }
    }
  });

  // Show "You're now shopping with" pop-up if "ghmodalname" querystring exists
  if (window.location.href.indexOf("ghmodalname") > -1 && checkAffiliateCookie() == false) {
    //if (window.location.href.indexOf("ghref") > -1) {
    var str_short_link = unescape(getQueryStringValue("ghmodalname"));
    str_short_link = str_short_link.replace(/\s+/g, " ").replace(/\s+/g, "-").toLowerCase();
    //console.log('gh_payload.partner_id:'+ gh_payload.partner_id);

    partnerID = gh_payload.partner_id;
    setPartner(partnerID);
    //}
  }

  $(".shop-with-new-partner-link").click(function () {
    delete_cookie("_growthhero_payload");
    delete_cookie("_blushington_shop_with_me");
    delete_cookie("_blushington_compare_artists");
  });

  blush_cookie_exists = checkAffiliateCookie();

  $(".blush-shop-with").mouseover(function () {
    if (blush_cookie_exists) {
      $(".shop-with-profile").addClass("hide");
      $(".shop-with-links").removeClass("hide");
    }
  });

  $(".blush-shop-with").click(function () {
    if (blush_cookie_exists) {
      $(".shop-with-profile").addClass("hide");
      $(".shop-with-links").removeClass("hide");
    }
  });

  $(".blush-shop-with").mouseout(function () {
    if (blush_cookie_exists) {
      $(".shop-with-links").addClass("hide");
      $(".shop-with-profile").removeClass("hide");
    }
  });

  $(".shop-with-img-div").click(function () {
    if ($("shop-with-me-badge #shop-with-me-badge-notification").hasClass("active")) {
      $("shop-with-me-badge #shop-with-me-badge-notification").removeClass("active");
    } else {
      $("shop-with-me-badge #shop-with-me-badge-notification").addClass("active");
    }
  });

  $("shop-with-me-badge .modal__close-button").click(function () {
    $("shop-with-me-badge #shop-with-me-badge-notification").removeClass("active");
  });

  $(".shop-with-compare-text").on("click", "a.btn", function () {
    //console.log("shop-with-compare-text: true");
    var vid = $(this).data("variantid");
    var artist_choice = $(this).data("choice");
    var reload_page = "reload";
    if (artist_choice == "new") {
      delete_cookie("_growthhero_payload");
      delete_cookie("_blushington_shop_with_me");
      if ($("body.template-growthhero_partner_page")[0]) {
        //blush_payload = '{"partner_id":"'+ $("#\\#_gh_variable_partner_id").text() +'", "full_name":"'+ $("#\\#_gh_variable_partner_name").text() +'","shop_url":"/pages/'+ $('#partner_link').attr('data-link') +'","photo_url":"'+ $("#\\#_gh_variable_partner_picture").text() +'"}'
        setShopWithMeCookie($("#\\#_gh_variable_partner_id").text(), $("#\\#_gh_variable_partner_picture").text());
        //addItemToCart( this, vid, 1, "1", "", reload_page);
      } else {
        //blush_payload = '{"partner_id":"'+ $("#blush_new_swm_div .ghid").text() +'", "full_name":"'+ $("#blush_new_swm_div .ghname").text() +'","shop_url":"/pages/'+ $('#blush_new_swm_div .ghlink').text() +'","photo_url":"'+ $("#blush_new_swm_div .ghimg").text() +'"}'
        setShopWithMeCookie($("#blush_new_swm_div .ghid").text(), $("#blush_new_swm_div .ghimg").text());
      }
      //document.cookie = "_blushington_shop_with_me" + "=" + blush_payload + ";30;path=/";
    } else if (artist_choice == "goto-current") {
      reload_page = shortLink;
      //console.log("artist_choice: "+ artist_choice);
      if ($("body.template-growthhero_partner_page")[0]) {
        //addItemToCart( this, vid, 1, "1", "", reload_page);
      } else {
        fn_reloadPage(reload_page);
      }
    } else {
      if ($("body.template-growthhero_partner_page")[0]) {
        //addItemToCart( this, vid, 1, "1", "", reload_page);
      }
    }
    //document.cookie = '_blushington_compare_artists={"compare"="false"};30;path=/';
    //console.log("vid: "+ vid);
    $(".shop-with-compare").css("display", "none");
    return false;
  });

  if ($("body").hasClass("template-cart")) {
    blush_cookie_exists = checkAffiliateCookie();
    blush_share_cart = getCookie("_blushington_share_cart");
    //console.log("blush_swm", blush_swm);
    //console.log("blush_cookie_exists", blush_cookie_exists)
    if (blush_swm) {
      if (typeof blush_swm.full_name !== "undefined") {
        nameArr = blush_swm.full_name.split(" ");
      } else {
        nameArr = ["", ""];
      }
    }
    if (blush_share_cart == "true") {
      delete_cookie("_blushington_share_cart");
      if (blush_cookie_exists) {
        //console.log("blush_swm.full_name: "+ nameArr[0]);
        $("#cart_title").text("Your Personalized Recommendations From " + nameArr[0]);
        var intro_text =
          'I hope you love the products I\'ve selected for you! You can <a href="https://blushington.com/collections/all" alt="Shop Blushington\'s Complete Collection">Add More Items</a> or <a href="#checkout-buttons" alt="Check Out Now">Check Out</a> now.';
        $("#saved_cart_intro").html(intro_text);
        $("#saved_cart_intro_div").removeClass("hide");
      }
    }
    if (blush_cookie_exists) {
      $("#reccomended-class").addClass("hide");
      $("#gh_partner-img-div").html(
        '<img id="gh_partner-img" class="gh-partner-img" style="max-width: 200px; max-height: 200px;" src="' +
          blush_swm.photo_url +
          '">'
      );
      $("#gh_partner-name").text(blush_swm.full_name);
      $("#gh_partner-bio").html(
        'I hope you love your purchases. Please reach out to me for some of my tips and tricks, or if you have any questions. Warmest regards, <a href="mailto:' +
          blush_swm.email +
          '" target="_blank">' +
          nameArr[0] +
          "</a>"
      );
      $("#gh_partner-div").removeClass("hide");
    }
  }

  //console.log( "ready!" );
  var cart_url = $("#aod_smart_cart_saver").attr("url") + "?ghref=4962:" + ghid;
  var cartLink = "?ghref=4962:" + ghid;

  let div = document.createElement("div");
  div.className = "copy_link_div";
  div.innerHTML = cartLink;
  waitForElementToDisplay(
    "#aod_smart_cart_saver .ml-2 b",
    function () {
      $("#aod_smart_cart_saver .ml-2 b").append(cartLink);
    },
    1000,
    9000
  );
});

function checkAffiliateCookie() {
  var blush_cookie = false;
  var d = new Date();
  //console.log("checkAffiliateCookie");
  //console.log(window.location.href);
  if (window.location.href.indexOf("?sas=") > -1) {
    //console.log("sas");
    delete_cookie("_growthhero_payload");
    delete_cookie("_blushington_shop_with_me");
    delete_cookie("_blush_no_gh");
    updateShopWithMeBadge("clear");

    var str_sas = getQueryStringValue("sas");
    if (str_sas == "1") {
      var str_sas = "shareasale";
    }

    if (window.location.href.indexOf("&dt=") > -1) {
      var dt = getQueryStringValue("dt");
      //2021-06-30T23:59:59.000+04:00
      //console.log("dt: "+ dt);
      d = new Date(dt);
    } else if (window.location.href.indexOf("&t=") > -1) {
      var t = getQueryStringValue("t");
      //2021-06-30T23:59:59.000+04:00
      //console.log("t: "+ t);
      //set cookie expiration to "t" days from now
      d.setDate(d.getDate() + t);
    } else {
      //default: set cookie expiration to one day from now
      d.setDate(d.getDate() + 1);
    }
    var c = "_blush_no_gh" + "=" + str_sas + ";path=/; expires=" + d.toUTCString();
    //console.log(c);
    document.cookie = c;
  } else if (getAffiliateCookie("_blush_no_gh") != null) {
    //console.log("_blush_no_gh");
    delete_cookie("_growthhero_payload");
    delete_cookie("_blushington_shop_with_me");
    updateShopWithMeBadge("clear");
  } else {
    // Get cookie using our custom function
    gh_payload = JSON.parse(getAffiliateCookie("_growthhero_payload"));
    //console.log("_growthhero_payload: " + gh_payload);
    blush_swm = JSON.parse(getAffiliateCookie("_blushington_shop_with_me"));

    if (gh_payload != null) {
      //console.log("gh_payload != null: " + gh_payload.partner_id);
      if (blush_swm != null) {
        //console.log("blush_swm != null: " + blush_swm);
        //console.log("blush_swm partner_id: " + blush_swm.partner_id);
        if (blush_swm.partner_id == gh_payload.partner_id && blush_swm.photo_url != "") {
          //console.log("blush_swm.photo_url != null: " + blush_swm);
          updateShopWithMeBadge(blush_swm);
          blush_cookie = true;
        } else {
          setShopWithMeCookie(gh_payload.partner_id);
        }
      } else {
        setShopWithMeCookie(gh_payload.partner_id);
      }
    } else if (blush_swm != null && blush_swm.photo_url != "") {
      updateShopWithMeBadge(blush_swm);
      blush_cookie = true;
    } else {
      updateShopWithMeBadge("hide");
    }
  }
  return blush_cookie;
}

function getAffiliateCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name == cookiePair[0].trim()) {
      //console.log('cookie key-vals: '+ cookiePair[0].trim() + ' = ' + cookiePair[1]);
      // Decode the cookie value and return
      if (typeof cookiePair[1] !== "undefined" && cookiePair[1].length) {
        return cookiePair[1];
      }
    }
  }

  // Return null if not found
  return null;
}

function setShopWithMeCookie(partnerID, partnerPhotoURL) {
  // Get GrowthHero Partner data via Shopify App Proxy (same-origin)
  //console.log( 'partnerPhotoURL', partnerPhotoURL );
  var request = new XMLHttpRequest();

  request.open("GET", "/a/rt/gh_partner.php?sl=" + encodeURIComponent(partnerID));

  request.onreadystatechange = function () {
    if (this.readyState === 4) {
      var raw = this.responseText || "";
      var partner;

      try {
        partner = JSON.parse(raw);
      } catch (e) {
        if (window.console && console.error) {
          console.error(
            "setShopWithMeCookie: partner JSON parse failed",
            e && e.message ? e.message : e,
            "responseText(head)=" + raw.slice(0, 200)
          );
        }
        return;
      }

      // Build cookie JSON safely (do not hand-escape commas/quotes)
      var blushObj = {
        partner_id: String(partnerID || ""),
        full_name: String(partner["name"] || ""),
        email: String(partner["email"] || ""),
        shop_url: "/pages/" + String((partner["additionalFields"] && partner["additionalFields"]["shortLink"]) || ""),
        photo_url: String((partner["additionalFields"] && partner["additionalFields"]["photo"]) || "")
      };

      var ghObj = {
        partner_id: String(partnerID || ""),
        group_id: String(partner["groupId"] || "")
      };

      // Preserve existing behavior: cookies store JSON strings (not URL-encoded)
      var blush_payload = JSON.stringify(blushObj);
      var gh_payload = JSON.stringify(ghObj);

      document.cookie = "_blushington_shop_with_me" + "=" + blush_payload + ";30;path=/";
      document.cookie = "_growthhero_payload" + "=" + gh_payload + ";30;path=/";

      // Preserve existing globals downstream
      blush_swm = blushObj;
      updateShopWithMeBadge(blush_swm);
    }
  };

  request.send();
}

function updateShopWithMeBadge(blush_swm) {
  //console.log('blush_swm', blush_swm);
  //console.log('partnerPhotoURL',partnerPhotoURL);
  if (blush_swm == "clear") {
    if (!$(".shop-with-me-badge .badge-hide").hasClass("hide")) {
      $(".shop-with-me-badge .badge-hide").addClass("hide");
    }
    if (!$("cart-notification .shop-with-me-badge").hasClass("hide")) {
      $("cart-notification .shop-with-me-badge").addClass("hide");
    }
    $(".shop-with-me-badge .shop-with-me-badge-button").attr("href", "");
    $(".shop-with-me-badge img.shop-with-img").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0470/1185/6536/files/spacer-1x1.gif"
    );
    $(".shop-with-me-badge .shop-with-partner-name").text("");
  } else if (blush_swm == "hide") {
    if (!$(".shop-with-me-badge .badge-hide").hasClass("hide")) {
      $(".shop-with-me-badge .badge-hide").addClass("hide");
    }
    if (!$("cart-notification .shop-with-me-badge").hasClass("hide")) {
      $("cart-notification .shop-with-me-badge").addClass("hide");
    }
  } else {
    //blush_partnerID = blush_swm.partner_id;
    blush_partnerID = partnerID;
    $(".shop-with-me-badge .shop-with-me-badge-button").attr("href", blush_swm.shop_url);
    //$(".shop-with-me-badge img.shop-with-img").attr("src", blush_swm.photo_url);
    $(".shop-with-me-badge img.shop-with-img").attr("src", partnerPhotoURL);
    $(".shop-with-me-badge .shop-with-partner-name").text(blush_swm.full_name);
    if ($(".shop-with-me-badge .badge-hide").hasClass("hide")) {
      $(".shop-with-me-badge .badge-hide").removeClass("hide");
    }
    if ($("cart-notification .shop-with-me-badge").hasClass("hide")) {
      $("cart-notification .shop-with-me-badge").removeClass("hide");
    }
  }
}

function addItemToCart(btnObj, variant_id, qty, frequency, unit_type, reload_page) {
  product_info = {
    id: variant_id,
    quantity: qty,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: product_info,
    dataType: "json",
    success: function (data) {
      fn_reloadPage(reload_page);
    },
    error: function (err) {
      fn_reloadPage($(btnObj).attr("data-url"));
    },
  });
}

function fn_reloadPage(reload_page) {
  //console.log ('fn_reloadPage: '+ reload_page);
  if (reload_page != "reload") {
    location.assign(reload_page);
  } else {
    location.reload(true);
  }
}

function delete_cookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    } else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}

function CopyToClipboard(containerid) {
  /* Get the text field */
  var copyText = document.getElementById(containerid);

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /* For mobile devices */

  /* Copy the text inside the text field */
  document.execCommand("copy");

  /* Alert the copied text */
  alert("Copied the text: " + copyText.value);
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setPartner(partnerID) {
  var val = false;
  //console.log('setPartner partnerID', partnerID);

  // CHANGED: absolute -> relative; remove custom headers to avoid preflight
  fetch("/a/rt/gh_partner.php?sl=" + encodeURIComponent(partnerID), {
    method: "GET",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((partner) => {
      //console.log('setPartner', partner);
      var partnerName = partner["name"];
      var partner_img = partner["additionalFields"]["photo"];
      //console.log('partner_img', partner_img);
      if (checkAffiliateCookie() == false) {
        //console.log('checkAffiliateCookie false - setCookie');
        setShopWithMeCookie(partnerID, partner_img);
      } else {
        //console.log('blush_new_swm_div');
        $("#blush_new_swm_div .ghid").text(partnerID);
        $("#blush_new_swm_div .ghname").text(partnerName);
        $("#blush_new_swm_div .ghimg").text(partner_img);
      }
      val = true; // This will still be false when the function returns; see explanation below
    })
    .catch((error) => {
      console.error("There has been a problem with your fetch operation:", error);
    });

  return val; // This will return false immediately, as fetch is asynchronous
}